import { useShowContext } from 'framework/show';
import { useMessageService, ErrorMessage, SuccessMessage } from 'framework/ui/Message';
import useEmployeesForAssingService from '../shared/fields/AssingEmployee/useEmployeesForAssingService';
import useEmployeesDashboardService from '../useEmployeesDashboardService';
import { DashboardEmployee } from '../types';

export const useCoordinatorManagement = () => {
  const { data, setData } = useShowContext<DashboardEmployee>();
  const { assigneEmployeeAction } = useEmployeesDashboardService();
  const { addMessage } = useMessageService();
  const { employees } = useEmployeesForAssingService();

  const employeeData = data?.getData();
  const riskId = employeeData?.retentionRiskId;

  const handleChangeStaffingCoordinator = async (selectedEmployeeAlias: string | null) => {
    try {
      await assigneEmployeeAction(riskId, { assigneeAlias: selectedEmployeeAlias });
      setData!({
        ...data.getData(),
        retentionRiskAssigneeAlias: selectedEmployeeAlias,
      });
      const message = selectedEmployeeAlias
        ? 'Staffing coordinator changed successfully'
        : 'Staffing coordinator unassigned successfully';
      addMessage(new SuccessMessage(message));
    } catch (error) {
      addMessage(new ErrorMessage('Failed to change staffing coordinator'));
    }
  };

  const coordinatorOptions = [
    {
      key: 'unassign-coordinator',
      label: 'Unassign',
      onClick: () => handleChangeStaffingCoordinator(null),
    },
    ...employees.map(employee => ({
      key: `coordinator-${employee.alias}`,
      label: employee.name,
      disabled: employee.alias === employeeData.retentionRiskAssigneeAlias,
      onClick: () => handleChangeStaffingCoordinator(employee.alias),
    })),
  ];

  const assignCallbacks = {
    onAssign: async (entityId: string, assigneeAlias: string | null) => {
      await handleChangeStaffingCoordinator(assigneeAlias);
    },
  };

  return {
    handleChangeStaffingCoordinator,
    coordinatorOptions,
    assignCallbacks,
    assigneeOptions: employees,
  };
};
